var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2C1.44772 2 1 2.44772 1 3V11C1 11.5523 1.44772 12 2 12H14C14.5523 12 15 11.5523 15 11V3C15 2.44772 14.5523 2 14 2Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14L9.25 12H6.75L6.5 14H9.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14H4.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64727 11.3527C1.55345 11.2589 1.50052 11.1318 1.5 10.9992V10H7.999C7.93414 10.0001 7.86914 10.0064 7.80491 10.0192C7.61093 10.0578 7.43275 10.153 7.29289 10.2929C7.15304 10.4327 7.0578 10.6109 7.01922 10.8049C6.98063 10.9989 7.00043 11.2 7.07612 11.3827C7.09289 11.4232 7.11223 11.4623 7.13397 11.5H2.00083C1.86817 11.4995 1.74108 11.4466 1.64727 11.3527ZM8.00099 10H14.5V10.9992C14.4995 11.1318 14.4466 11.2589 14.3527 11.3527C14.2589 11.4466 14.1318 11.4995 13.9992 11.5H8.86603C8.95304 11.3493 9 11.1771 9 11C9 10.8022 8.94135 10.6089 8.83147 10.4444C8.72159 10.28 8.56541 10.1518 8.38268 10.0761C8.26108 10.0257 8.13135 10.0001 8.00099 10Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.7fe880b6613e801d89a10bca0738ff18.svg";
export { ForwardRef as ReactComponent };